import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { PAEmailRequest } from "./PAEmailRequest";
import { PersonRegisteredUsersRequest } from "./person-registered-users-request";
import { PAQRCodeSelectRequest } from "./PAQRCodeSelectRequest";
import { RegPersonToggleRequest } from "./reg-person-toggle-request";
@Injectable()
export class DataService_Student_PortalAppReg {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	PortalAppQRCodeSelect(parms: PAQRCodeSelectRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppQRCodeSelect";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppQRCodePrint(parms: PAQRCodeSelectRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppQRCodePrint";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PortalAppQRCodeEmail(parms: PAQRCodeSelectRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PortalAppQRCodeEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PersonRegisteredUsersSelectList(parms: PersonRegisteredUsersRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/PersonRegisteredUsersSelectList";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegPersonToggle(parms: RegPersonToggleRequest) {
		var postResult$ = new Subject();
		var url = "PortalApps/RegPersonToggle";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
